import { render, staticRenderFns } from "./BoardHeaderGroup.vue?vue&type=template&id=b930ade6&scoped=true&"
import script from "./BoardHeaderGroup.vue?vue&type=script&lang=ts&"
export * from "./BoardHeaderGroup.vue?vue&type=script&lang=ts&"
import style0 from "./BoardHeaderGroup.vue?vue&type=style&index=0&id=b930ade6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b930ade6",
  null
  
)

export default component.exports